import React from "react";
import { useMemo } from "react";
import { getOrderDocuments } from "../../../obps/src/utils";
import { Box, Card } from "@mui/material";
import {
  CardHeader, Row, StatusTable, Table
} from "@egovernments/digit-ui-react-components";
import { useTranslation } from "react-i18next";
import BPADocumentsPreview from "../../ApplicationDetails/components/BPADocumentsPreview";
import BPACheckListPreview from "../../ApplicationDetails/components/BPACheckListPreview";
import Avatar from "@material-ui/core/Avatar";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import CustomizedTables from "../../../obps/src/components/SummaryComponents/TableSummaryPage";
import { FaFilePdf } from "react-icons/fa";
import KhasraTables from "../../../obps/src/components/SummaryComponents/kasarTable";

const Form12ApplicaionFormatView = ({ formData, applicationDocs, totalAmount, edcrDetails }) => {
  const { t } = useTranslation()
  const { landInfo, professionaldetails } = formData
  const { checklistdata, owners, address } = landInfo
  const tenant = Digit.ULBService.getCurrentTenantId();
  const isTcp = formData?.applicationNo?.includes('TCP')
  const accessData = (plot) => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    }
  }
  const filteredDocuments = applicationDocs.filter(doc => !["applicantPhoto", "signature","OwnerPhoto"].includes(doc.documentType));
  const checklistfilteredCertificate = applicationDocs.filter(doc => ["landInfo.checklist.structuralStabilityCertificate"].includes(doc.documentType));
  const checklistfilteredPhoto = applicationDocs.filter(doc => ["checklist.PhotographsOfSite"].includes(doc.documentType));
  const nocFromHPSEBcertificate = applicationDocs.filter(doc => ["checklist.nocFromHPSEB"].includes(doc.documentType));
  const whetherNearbyAsiMonument_noccertificate = applicationDocs.filter(doc => ["checklist.whetherNearbyAsiMonument_noc"].includes(doc.documentType));
  const whetherNearbyHfl_noccertificate = applicationDocs.filter(doc => ["checklist.whetherNearbyHfl_noccertificate"].includes(doc.documentType));
  const nocFromNHAI = applicationDocs.filter(doc => ["checklist.nocFromNHAI"].includes(doc.documentType));
  const whetherSeweragePassingThrough_noccertificate = applicationDocs.filter(doc => ["checklist.whetherSeweragePassingThrough_noccertificate"].includes(doc.documentType));
  const whetherSlidingArea_doc = applicationDocs.filter(doc => ["checklist.whetherSlidingArea_doc"].includes(doc.documentType));
  const whetherAirportPermissionRequired_noc = applicationDocs.filter(doc => ["checklist.whetherAirportPermissionRequired_noc"].includes(doc.documentType));
  const tableHeader = [
    {
      name: "BPA_TABLE_COL_FLOOR",
      id: "Floor",
    },
    {
      name: "BPA_TABLE_COL_LEVEL",
      id: "Level",
    },
    {
      name: "BPA_TABLE_COL_OCCUPANCY",
      id: "Occupancy",
    },
    {
      name: "BPA_TABLE_COL_BUILDUPAREA",
      id: "BuildupArea",
    },
    {
      name: "BPA_TABLE_COL_FLOORAREA",
      id: "FloorArea",
    },
    {
      name: "BPA_TABLE_COL_CARPETAREA",
      id: "CarpetArea",
    }
  ]
  const tableColumns = useMemo(
    () => {

      return tableHeader.map((ob) => ({
        Header: t(`${ob.name}`),
        accessor: accessData(ob.id),
        id: ob.id,
        //symbol: plot?.symbol,
        //sortType: sortRows,
      }));


    });
  function getFloorData(block) {
    let floors = [];
    block?.building?.floors.map((ob) => {
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${ob.occupancies?.[0]?.type}`),
        BuildupArea: ob.occupancies?.[0]?.builtUpArea,
        FloorArea: ob.occupancies?.[0]?.floorArea || 0,
        CarpetArea: ob.occupancies?.[0]?.CarpetArea || 0,
        key: t(`BPA_FLOOR_NAME_${ob.number}`),
      });
    });
    return floors;
  }
  const urlImg = isTcp ? "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" : "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg"

  const nameOfDepartment = isTcp ? "Department of Town and Country Planning" : "UP Housing & Development Board"

  return (
    <React.Fragment>
      <div style={{
        marginTop: "1px",
        backgroundColor: "#fff",
      }}>

        <div>
          <div style={{ display: "flex", padding: "5px", marginLeft: "15px" }}>
            <img width="60" height="30" src={urlImg} alt="Himachal" />
            <div style={{ color: "blue" }}><p style={{ marginLeft: "12px", fontSize: "23px", marginTop: "6px" }}>{nameOfDepartment}</p><p style={{ marginLeft: "12px", marginTop: "4px" }}>{'Hamara Prayas....Aapka Awas'}</p></div></div>
        </div>
        <strong> <hr /> </strong>
        <br />
        <div style={{
          textAlign: "center", marginBottom: "5px",
          backgroundColor: "#99b3d98c",
          border: "1px solid rgba(91, 90, 95, 0.35)"
        }}><b>Map Submission</b></div>
        {/* <Card style={{ backgroundColor: "#eeeab5b0", padding: "20px" }}>
        Map Submission
        </Card> */}
        <Card style={{
          paddingBottom: " 15px",
          marginTop: "5px",
          marginBottom: "5px"
        }}>
          <div style={{
            textAlign: "center", marginBottom: "5px",
            backgroundColor: "#99b3d98c",
            border: "1px solid rgba(91, 90, 95, 0.35)"
          }}><b>Application Details </b></div>
          <div className="row" style={{ marginLeft: "0px" }}>
            <div style={{ width: "90%" }}>
              <div>
                {owners?.map((item, index) => (
                  <div key={`${item?.mobileNumber}_${index}`} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div style={{
                      width: '60%',
                      marginLeft: "2%",
                      marginTop: "15px"
                    }}>
                      <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Name :</p> <p> {item?.name}</p></span>
                      <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Father/Guardian Name :</p> <p> {item?.fatherOrHusbandName}</p></span>
                      <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Gender :</p> <p> {item?.gender}</p></span>
                      <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>MobileNumber :</p> <p> {item?.mobileNumber}</p></span>
                      <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Email :</p> <p> {item?.emailId}</p></span>
                      <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Application Number :</p> <p> {formData?.applicationNo}</p></span>
                    </div>
                    <div style={{ width: '25%', marginTop: "auto" }}>
                      <div className="row" style={{ margin: "4px" }}>
                        {item?.photo ? (
                          <img style={{ width: "110px", height: "110px" }} src={item?.photo} alt={'image'} className="img-thumbnail" />
                        ) : (
                          <Avatar style={{ width: "70px", height: "70px" }}>{item?.photo}</Avatar>
                        )}
                      </div>
                      <div className="row" style={{ margin: "4px" }}>
                        {item?.signature ? (
                          // <img width="70px" height="30px" src={item?.signature} alt={'image'} />
                          <img style={{ width: "110px", height: "40px" }} src={item?.signature} alt={'signature'} className="img-thumbnail" />
                        ) : (
                          <BorderColorIcon style={{ width: "70px", height: "25px" }}>{item?.signature}</BorderColorIcon>
                        )}
                      </div>
                    </div>

                  </div>
                ))}
              </div>
            </div>

          </div>


        </Card>
        <Card style={{
          paddingBottom: " 15px",
          marginTop: "5px",
          marginBottom: "5px"
        }}>
          <div style={{
            textAlign: "center", marginBottom: "5px",
            backgroundColor: "#99b3d98c",
            border: "1px solid rgba(91, 90, 95, 0.35)"
          }}><b>Address Details </b></div>
          <div className="row">
            <div style={{ width: "50%" }}>
              <div style={{
                margin: "3px", border: "2px solid rgba(91, 90, 95, 0.35)", backgroundColor: "#99b3d98c", marginTop: "14px",
                // padding: "4px",
                textAlign: "center",
                marginBottom: "10px"
              }}><b>Correspondance Address</b></div>
              <div style={{ marginLeft: "7%", marginRight: "5%" }}>
                {owners?.map((item, index) => (
                  <div key={index}>

                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Address :</p> <p> {item?.correspondenceAddress?.address || 'N/A'}</p></span>
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>State :</p> <p> {item?.correspondenceAddress?.state || 'Uttar Pradesh'}</p></span>
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>District :</p> <p> {item?.correspondenceAddress?.district || 'N/A'}</p></span>
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Tehsil :</p> <p> {item?.correspondenceAddress?.tehsil || 'N/A'}</p></span>
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Town/Village/Ward :</p> <p> {item?.correspondenceAddress?.town || 'N/A'}</p></span>
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>PinNo : </p> <p> {item?.correspondenceAddress?.pinno || 'N/A'}</p></span>

                  </div>
                ))}
              </div>
            </div>
            <div style={{ width: "50%" }}>
              <div style={{
                margin: "3px", border: "2px solid rgba(91, 90, 95, 0.35)", backgroundColor: "#99b3d98c", marginTop: "14px",
                // padding: "4px",
                textAlign: "center",
                marginBottom: "10px"
              }}><b>Permanent Address</b></div>
              <div style={{ marginLeft: "7%", marginRight: "5%" }}>
                {owners?.map((item, index) => (
                  <div key={index}>
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Address :</p> <p> {item?.permanentAddress?.address || 'N/A'}</p></span>
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>State :</p> <p> {item?.permanentAddres?.state || 'Uttar Pradesh'}</p></span>
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>District :</p> <p> {item?.permanentAddress?.district || 'N/A'}</p></span>
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Tehsil :</p> <p> {item?.permanentAddress?.tehsil || 'N/A'}</p></span>
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Town/Village/Ward :</p> <p> {item?.permanentAddress?.town || 'N/A'}</p></span>
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>PinNo : </p> <p> {item?.permanentAddress?.pinno || 'N/A'}</p></span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Card>
        <Card style={{
          paddingBottom: " 15px",
          marginTop: "5px",
          marginBottom: "5px"
        }}>
          <div style={{
            textAlign: "center",
            backgroundColor: "#99b3d98c",
            padding: "5px",
            color: "black",
            border: " 2px solid rgba(91, 90, 95, 0.35)"
          }}><b>Description Of Land Proposed for Development of Land/Construction of Building</b></div>
          <div className="row" style={{ marginLeft: "0px" }}>
            <div style={{ width: "90%" }}>
              <div className="row" style={{ marginLeft: "1%", marginTop: "1%" }}>
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Revenue Village/Mohalla :</p> <p>{formData?.revenueVillageMohal || 'N/A'} </p></span>
                </div>
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Khatuni No :</p> <p> {formData?.khatauniNo || 'N/A'}</p></span>
                </div>
                <br />
               <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Applied Land Use:  </p> <p> {formData?.typeofArea || 'N/A'}</p></span>
                </div>
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Khata No :</p> <p>{formData?.khataNo || 'N/A'} </p></span>
                </div>
                <br />
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Total Plot Area: </p> <p> {formData?.plotArea || 'N/A'}</p></span>
                </div>
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>District:  </p> <p> {address?.city || 'N/A'}</p></span>
                </div>
                <br />
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    {isTcp ? <span style={{ display: "flex" }}> <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Notified Area:  </p> <p> {address?.doorNo || 'N/A'}</p></span> : <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>ULB:  </p> <p> {address?.doorNo || 'N/A'}</p></span>}
                  </span>
                </div>
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Area Type:  </p> <p> {address?.areaType || 'N/A'}</p></span>
                </div>
                <br />
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Property Type:  </p> <p> {formData?.propertyType || 'N/A'}</p></span>
                </div>
               
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Case Ref No: </p> <p>  {formData?.caseReferenceNo || 'N/A'}</p></span>
                </div>
                <br />
               
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>No of Blocks:  </p> <p> {formData?.noOfBlocks || 'N/A'}</p></span>
                </div>
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Risk Type:  </p> <p> {formData?.riskType || 'N/A'}</p></span>
                </div>
                <br/>
              <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Number of Plot:  </p> <p>{formData?.noOfPlot || 'N/A'}</p></span>
                </div>
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}> Latitude/Longitude: </p> <p> {formData?.latLong || 'N/A'}</p></span>
                </div>
                <br />
                {formData?.constructionType && (
                  <div className="col-6">
                    <span style={{ display: "flex" }}>
                      <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Type of Construction: </p> <p> {formData?.constructionType || 'N/A'}</p></span>
                  </div>
                )}
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Whether Subdivision Approved:  </p> <p>{formData?.whetherSubdivisionApproved || 'N/A'}</p></span>
                </div>
                <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Whether Property is ancestral:  </p> <p>{formData?.isAncestralProperty || 'N/A'}</p></span>
                </div>
                  <br/>
                
                  <div className="col-6">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Muck to be disposed (cubic mt.):  </p> <p> {formData?.landInfo?.checklistdata?.muckToBeDisposed || 'N/A'}</p></span>
                </div>
                  <br />
                  <div className="col-12">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Maximum Permissible Ground Coverage (in Sq.mt):  </p> <p> {formData?.maximumPermissibleGroundCoverage || 'N/A'}</p></span>
                </div>
                  <br />
                 
                <div className="col-12">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Proposal Submitted For:  </p> <p> {formData?.proposal || 'N/A'}</p></span>
                </div>
                  <br/>
                 <div className="col-12">
                  <span style={{ display: "flex" }}>
                    <p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Plot Area for Sub-division/Development Activity:   </p> <p> {formData?.totalPlotArea || 'N/A'}</p></span>
                </div>
                <br />
                <br />
                {formData?.khasraArea && (
                  <KhasraTables
                    formData={formData}
                  />
                )}
              </div>
            </div>
          </div>
        </Card>
        {formData?.blocks && (
          <Card style={{
            paddingBottom: " 15px",
            marginTop: "5px",
            marginBottom: "5px"
          }}>
            <div style={{
              textAlign: "center",
              backgroundColor: "#99b3d98c",
              padding: "5px",
              color: "black",
              border: " 2px solid rgba(91, 90, 95, 0.35)"
            }}><b>Details of Blocks</b></div>
            <div style={{ margin: "1%" }}>
              <div className="row">
                <div className="col-6">
                  {formData?.edcrReport && (
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>edcr-Report :</p>
                      <p> <a target="_" href={formData?.edcrReport} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                        <p>
                          <FaFilePdf color="#a10505" style={{ width: '20px', height: '30px' }} />
                        </p>
                      </a></p></span>
                  )}
                </div>
                <div className="col-6">
                  {formData?.drawingPdf && (
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>DrawingPdf :</p>
                      <p> <a target="_" href={formData?.drawingPdf} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                        <p>
                          <FaFilePdf color="#a10505" style={{ width: '20px', height: '30px' }} />
                        </p>
                      </a></p></span>
                  )}
                </div>
              </div>
              <br />
              <br />
              <h4>Occupancy : {formData?.occupancy}</h4>

              {formData?.blocks?.map((block, index) => (
                <div style={{ overflow: "scroll" }} key={index}>

                  <div>blocks Number : {index + 1}</div>

                  <Table
                    className="customTable table-fixed-first-column table-border-style"
                    t={t}
                    disableSort={false}
                    autoSort={true}
                    manualPagination={false}
                    isPaginationRequired={false}
                    initSortId="S N "
                    data={getFloorData(block)}
                    columns={tableColumns}
                    getCellProps={(cellInfo) => {
                      return {
                        style: {},
                      };
                    }}
                  />
                  <br></br>
                </div>
              ))}

            </div>
          </Card>
        )}

        {/* <Card style={{
          paddingBottom: " 15px",
          marginTop: "5px",
          marginBottom: "5px"
        }}>
          <div style={{
            textAlign: "center",
            backgroundColor: "#99b3d98c",
            padding: "5px",
            color: "black",
            border: " 2px solid rgba(91, 90, 95, 0.35)"
          }}><b>Plot Details</b></div>
          <div className="row">
            <div style={{ width: "49%" }}>
              <div style={{ marginLeft: "7%", marginRight: "5%", marginTop: "1%" }}>
                <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Whether Change of Land Use Involved :</p>
                  <p>  {formData?.cluInvolved?.name || 'N/A'}</p></span>
              </div>
            </div>
            <div style={{ width: "49%" }}>
              <div style={{ marginLeft: "7%", marginRight: "5%", marginTop: "1%" }}>
                <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Type Of CLU Involved :</p>
                  <p> {formData?.cluType?.code || ":--"}</p></span>
              </div>
            </div>
          </div>
        </Card> */}
        {/* {formData?.cluInvolved?.name === "yes" && (
          <Card style={{
            paddingBottom: " 15px",
            marginTop: "5px",
            marginBottom: "5px"
          }}>
            <div style={{
              textAlign: "center",
              backgroundColor: "#99b3d98c",
              padding: "5px",
              color: "black",
              border: " 2px solid rgba(91, 90, 95, 0.35)"
            }}><b>Details of Plot after Subdivision</b></div>
            <div className="row" style={{ margin: "1%" }}>
              <CustomizedTables
                landDevelopment={formData?.landDevelopment}
              />
            </div>
          </Card>
        )} */}
        {/* {professionaldetails?.name && (
          <Card style={{
            paddingBottom: " 20px",
            marginTop: "10px",
            marginBottom: "5px"
          }}><div style={{
            textAlign: "center",
            backgroundColor: "#99b3d98c",
            padding: "5px",
            color: "black",
            border: " 2px solid rgba(91, 90, 95, 0.35)"
          }}><b>Private Professional Information</b></div>
            <div className="row">
              <div style={{ width: "49%" }}>
                <div style={{ marginLeft: "7%", marginRight: "5%", marginTop: "1%" }}>
                  <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Name:</p>
                    <p> {professionaldetails?.name}</p></span>
                  <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Mobile Number:</p>
                    <p>  {professionaldetails?.mobileNumber}</p></span>
                </div>

              </div>
              <div style={{ width: "49%" }}>
                <div style={{ marginLeft: "7%", marginRight: "5%", marginTop: "1%" }}>
                  {professionaldetails?.address?.address && (
                  <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Address:</p>
                    <p> {professionaldetails?.address?.address}</p></span>
                  )}
                </div>
              </div>
            </div>
          </Card>
        )} */}
        {/* {professionaldetails?.ername && (
          <Card style={{
            paddingBottom: " 15px",
            marginTop: "5px",
            marginBottom: "5px"
          }}>
            <div style={{
              textAlign: "center",
              backgroundColor: "#99b3d98c",
              padding: "5px",
              color: "black",
              border: " 2px solid rgba(91, 90, 95, 0.35)"
            }}><b>Structural Engineer Information</b></div>
            <div className="row">
              <div style={{ width: "49%" }}>

                <div style={{ marginLeft: "7%", marginRight: "5%", marginTop: "1%" }}>
                  <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", overflow: "" }}>Type:</p>
                    <p> {professionaldetails?.type}</p></span>
                  <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Registration No:</p>
                    <p> {professionaldetails?.erregistrationNumber}</p></span>

                </div>
              </div>
              <div style={{ width: "49%" }}>
                <div style={{ marginLeft: "7%", marginRight: "5%", marginTop: "1%" }}>
                  <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Name:</p>
                    <p> {professionaldetails?.ername}</p></span>
                  <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Mobile Number:</p>
                    <p>  {professionaldetails?.ermobileNumber}</p></span>
                  {formData?.structureCertificateUrl && (
                    <span style={{ display: "flex" }}><p className="font-weight-bold" style={{ marginRight: "12px", whiteSpace: "nowrap" }}>Structural Stability Certificate :</p>
                      <p> <a target="_" href={formData?.structureCertificateUrl} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                        <p>
                          <FaFilePdf color="#a10505" style={{ width: '20px', height: '30px' }} />
                        </p>
                      </a></p></span>
                  )}
                </div>

              </div>
            </div>
          </Card>
        )} */}
        <Card style={{
          paddingBottom: " 15px",
          marginTop: "5px",
          marginBottom: "5px"
        }}>
          <div style={{
            textAlign: "center",
            backgroundColor: "#99b3d98c",
            padding: "5px",
            color: "black",
            border: " 2px solid rgba(91, 90, 95, 0.35)"
          }}><b>Documents/Maps</b></div>
          <div className="row">
            {<BPADocumentsPreview documents={getOrderDocuments(filteredDocuments)} svgStyles={{}} isSendBackFlow={false} isHrLine={true} titleStyles={{ fontSize: "18px", lineHeight: "24px", "fontWeight": 700, marginBottom: "10px" }} />}
          </div>
        </Card>
        <Card style={{
          paddingBottom: " 15px",
          marginTop: "5px",
          marginBottom: "5px"
        }}>
          <div style={{
            textAlign: "center",
            backgroundColor: "#99b3d98c",
            padding: "5px",
            color: "black",
            border: " 2px solid rgba(91, 90, 95, 0.35)"
          }}><b>CheckList</b></div>
          <div>
            <BPACheckListPreview certificate={checklistfilteredCertificate}
              nocFromHPSEBcertificate={nocFromHPSEBcertificate}
              whetherNearbyAsiMonument_noccertificate={whetherNearbyAsiMonument_noccertificate}
              whetherNearbyHfl_noccertificate={whetherNearbyHfl_noccertificate}
              nocFromNHAIcertificate={nocFromNHAI}
              whetherSeweragePassingThrough_noccertificate={whetherSeweragePassingThrough_noccertificate}
              whetherSlidingArea_doc={whetherSlidingArea_doc}
              photo={checklistfilteredPhoto}
              whetherAirportPermissionRequired_noc={whetherAirportPermissionRequired_noc}
              formData={checklistdata} />
          </div>
        </Card>

        {formData?.taxHeadEstimates?.map((item, index) => (
          <Box gridColumn="span 12" sx={{ ml: 2 }} key={index}>
            <Card style={{
              paddingBottom: " 20px",
              marginTop: "10px",
              marginBottom: "5px"
            }}>
              {/* New 02-03-24 Non Residentials  <500*/}
              {isTcp && formData?.plotArea < 500 && formData?.typeofArea !== "Residential" && (
                <div style={{
                  textAlign: "center",
                  backgroundColor: "#99b3d98c",
                  padding: "5px",
                  color: "black",
                  border: " 2px solid rgba(91, 90, 95, 0.35)"
                }}>Processing fee to Fee structure </div>
              )}
              {/*  Residentials  < 500*/}
              {isTcp && formData?.plotArea < 500 && formData?.typeofArea === "Residential" && (
                <div style={{
                  textAlign: "center",
                  backgroundColor: "#99b3d98c",
                  padding: "5px",
                  color: "black",
                  border: " 2px solid rgba(91, 90, 95, 0.35)"
                }}>Processing fee to Fee structure </div>
              )}
              {/*  Non Residentials &Residentials  greater then 500*/}
              {isTcp && formData?.plotArea > 500 && (
                <div style={{
                  textAlign: "center",
                  backgroundColor: "#99b3d98c",
                  padding: "5px",
                  color: "black",
                  border: " 2px solid rgba(91, 90, 95, 0.35)"
                }}>Processing fee to Fee structure </div>
              )}
              {/* ud Non Residentials less then 500*/}
              {!isTcp && formData?.plotArea < 500 && formData?.typeofArea != "Residential" && (
                <div style={{
                  textAlign: "center",
                  backgroundColor: "#99b3d98c",
                  padding: "5px",
                  color: "black",
                  border: " 2px solid rgba(91, 90, 95, 0.35)"
                }}>Incudling Application & Processing fee to Fee structure </div>
              )}
              {/* ud Non Residentials less then 500* 1st Payments */}
              {!isTcp && formData?.plotArea < 500 && formData?.typeofArea === "Residential" && index === 0 && (
                <div style={{
                  textAlign: "center",
                  backgroundColor: "#99b3d98c",
                  padding: "5px",
                  color: "black",
                  border: " 2px solid rgba(91, 90, 95, 0.35)"
                }}>Application Fee </div>
              )}
              {/* ud Non Residentials less then 500* 2st Payments */}
              {!isTcp && formData?.plotArea < 500 && formData?.typeofArea === "Residential" && index === 1 && (
                <div style={{
                  textAlign: "center",
                  backgroundColor: "#99b3d98c",
                  padding: "5px",
                  color: "black",
                  border: " 2px solid rgba(91, 90, 95, 0.35)"
                }}>Processing fee to Fee structure</div>
              )}
              {/* ud Residentials/Non residentails greater then 500* 1st Payments */}
              {!isTcp && formData?.plotArea > 500 && index === 1 && (
                <div style={{
                  textAlign: "center",
                  backgroundColor: "#99b3d98c",
                  padding: "5px",
                  color: "black",
                  border: " 2px solid rgba(91, 90, 95, 0.35)"
                }}>Processing fee to Fee structure</div>
              )}
              {!isTcp && formData?.plotArea > 500 && index === 0 && (
                <div style={{
                  textAlign: "center",
                  backgroundColor: "#99b3d98c",
                  padding: "5px",
                  color: "black",
                  border: " 2px solid rgba(91, 90, 95, 0.35)"
                }}>Application Fee</div>
              )}
 {item?.feeDetails?.deviationTable && (
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <td><p style={{ marginTop: "20px" }}><b>Floor No</b></p></td>
                      <td><p style={{ marginTop: "20px" }}><b>Use Type</b></p></td>
                      <td><p style={{ marginTop: "20px" }}><b>Total Area (Sq.M.)</b></p></td>
                      <td><p style={{ marginTop: "20px" }}><b>Unit Price()</b></p></td>
                      <td><p style={{ marginTop: "20px" }}><b>Price()</b></p></td>
                      <td><p style={{ marginTop: "20px" }}><b>Parking Area</b></p></td>
                    </tr>
                  </thead>
                  <tbody>

                    {item?.feeDetails?.deviationTable?.map((feeData, index) => (
                      <tr>
                        <td >{feeData?.floorType?.name}</td>
                        <td><b>{feeData?.landUseType?.name}</b></td>

                        <td >{feeData?.landUseType?.area}</td>
                        <td >{feeData?.landUseType?.unitPrice}</td>
                        <td >{feeData?.landUseType?.price}</td>
                        <td >{feeData?.floorType?.area}</td>



                      </tr>
                    ))}

                  </tbody>
                </table>
              )}

              <table class="table table-sm">
                <thead>
                  <p style={{ marginLeft: "10px", textAlign: "left" }}><b>Total Amount</b></p>
                </thead>
                <tbody>

                  {item?.applicationFee !== 0 && item?.applicationFee && (
                    <tr>
                      <td colspan="2">{t(`BPA_COMMON_APPLICATION_FEE`)}</td>
                      <td><b>{`₹ ${item?.applicationFee}`}</b></td>
                    </tr>
                  )}
                  {item?.buildUpCharges !== 0 && item?.buildUpCharges && (
                    <tr>
                      <td colspan="2">Building Permission Fee</td>
                      <td><b>{`₹ ${item?.buildUpCharges}`}</b></td>
                    </tr>
                  )}

                  {item?.cluFee !== 0 && item?.cluFee && (
                    <tr>
                      <td colspan="2">CLU Fee</td>
                      <td><b>{`₹ ${item?.cluFee}`}</b></td>
                    </tr>
                  )}
                  {item?.deviationCharges && item?.deviationCharges !== 0 && (
                    <tr>
                      <td colspan="2">Deviation Charges</td>
                      <td><b>{`₹ ${item?.deviationCharges}`}</b></td>
                    </tr>
                  )}
                  {item?.muckCharges !== 0 && item?.muckCharges && (
                    <tr >
                      <td colspan="2">Total Muck-Charges</td>
                      <td><b>{`₹ ${item?.muckCharges}`}</b></td>
                    </tr>
                  )}
                  {item?.totalCBMFees !== 0 && item?.totalCBMFees && (
                    <tr>
                      <td colspan="2"><b>Total Planning Permission Fee</b></td>
                      <td><b>{`₹ ${item?.totalCBMFees}`}</b></td>
                    </tr>
                  )}
                  {item?.premiumFARFee !== 0 && item?.premiumFARFee && (
                    <tr>
                      <td colspan="2">Premium FAR Fee</td>
                      <td><b>{`₹ ${item?.premiumFARFee}`}</b></td>
                    </tr>
                  )}
                  {item?.echarges !== 0 && item?.echarges && (
                    <tr>
                      <td colspan="2">e-charges (3%)</td>
                      <td><b>{`₹ ${item?.echarges}`}</b></td>
                    </tr>
                  )}
                  {item?.amountDisplay !== 0 && item?.amountDisplay && (
                    <tr>
                      <td colspan="2"><b>Grand Total Amount</b></td>
                      <td><b>{`₹ ${item?.amountDisplay}`}</b></td>
                    </tr>
                  )}

                </tbody>
              </table>
            </Card>
          </Box>
        ))}

<React.Fragment>
<Box gridColumn="span 12" sx={{ ml: 2 }} >
            <Card style={{
              paddingBottom: " 20px",
              marginTop: "10px",
              marginBottom: "5px"
            }}>
           <div style={{
                  textAlign: "center",
                  backgroundColor: "#99b3d98c",
                  padding: "5px",
                  color: "black",
                  border: " 2px solid rgba(91, 90, 95, 0.35)"
                }}>Processing fee to Fee structure </div>

<table class="table table-sm">
 
  <tbody>
   <tr>
   <td colspan="2"> Building Approval charges</td>
   <td><b>{`₹ 0`}</b></td>
   </tr>
   <tr>
   <td colspan="2">Malba Charges</td>
   <td><b>{`₹ 0`}</b></td>
   </tr>

   <tr>
   <td colspan="2">Water Charges</td>
   <td><b>{`₹ 0`}</b></td>
   </tr>
 
   <tr >
   <td colspan="2">Site Inspection Charges</td>
   <td><b>{`₹ 0`}</b></td>
   </tr>

   <tr>
   <td colspan="2">Shudhikaran Charges</td>
   <td><b>{`₹ 0`}</b></td>
   </tr>


</tbody>
</table>
          </Card>
          </Box>
          </React.Fragment>

      </div>
    </React.Fragment>
  );
}
export default Form12ApplicaionFormatView;